"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _base = _interopRequireDefault(require("../../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledButton = _styledComponents.default.button.attrs({
  type: "button"
})`
  align-items: center;
  display: block;
  border: none;
  background: none;
  box-shadow: none;
  cursor: pointer;
  height: 40px;
  width: 40px;
  padding: 0;
  &:focus {
    outline: ${({
  theme
}) => `3px solid ${theme.colors.focus}`};
  }
`;
StyledButton.defaultProps = {
  theme: _base.default
};
var _default = StyledButton;
exports.default = _default;